/* eslint-disable camelcase */
import {
  mdiCameraOff,
  mdiCellphone,
  mdiFood,
  mdiKabaddi,
  mdiMapMarkerDistance,
  mdiSeatbelt,
  mdiSleep, mdiSmoking,
  mdiTimer
} from '@mdi/js'
import Vuetify from '../../plugins/vuetify'

export class UserStatistics {
  constructor ({ distance = 0.0, duration = 0.0, distraction_count = 0, drowsiness_count = 0, nobelt_count = 0, camera_sabotage = 0, cellphone_use = 0, eating_count = 0, smoking_count = 0 } = {}) {
    this.distance = distance
    this.duration = duration
    this.distractionCount = distraction_count
    this.drowsinsessCount = drowsiness_count
    this.nobeltCount = nobelt_count
    this.cameraSabotage = camera_sabotage
    this.cellphoneUse = cellphone_use
    this.eatingCount = eating_count
    this.smokingCount = smoking_count
  }

  get durationLocalized () {
    let result = ''
    let day, hour, minute, seconds
    seconds = Math.floor(this.duration / 1000)
    minute = Math.floor(seconds / 60)
    seconds = seconds % 60
    hour = Math.floor(minute / 60)
    minute = minute % 60
    day = Math.floor(hour / 24)
    hour = hour % 24

    if (seconds > 0 && hour === 0 && day === 0) {
      result = ` ${seconds} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.seconds')}` + result
    }

    if (minute > 0 && day === 0) {
      result = ` ${minute} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.minutes')}` + result
    }

    if (hour > 0 && day <= 31) {
      result = ` ${hour} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.hours')}` + result
    }

    if (day > 0) {
      result = ` ${day} ${Vuetify.framework.lang.t('$vuetify.shared.abbreviation.days')}` + result
    }

    return result.trim()
  }

  statisticsState () {
    return [
      {
        title: '$vuetify.map.travelStats.distance.title',
        value: this.distance / 1000,
        icon: mdiMapMarkerDistance,
        postfix: '$vuetify.map.travelStats.distance.postfix'
      },
      {
        title: '$vuetify.map.travelStats.duration.title',
        value: this.durationLocalized,
        icon: mdiTimer
      },
      {
        title: '$vuetify.map.travelStats.distractionCount.title',
        value: this.distractionCount,
        icon: mdiKabaddi
      },
      {
        title: '$vuetify.map.travelStats.drowsinessCount.title',
        value: this.drowsinsessCount,
        icon: mdiSleep
      },
      {
        title: '$vuetify.map.travelStats.nobeltCount.title',
        value: this.nobeltCount,
        icon: mdiSeatbelt
      },
      {
        title: '$vuetify.map.travelStats.cameraSabotage.title',
        value: this.cameraSabotage,
        icon: mdiCameraOff
      },
      {
        title: '$vuetify.map.travelStats.cellphoneUse.title',
        value: this.cellphoneUse,
        icon: mdiCellphone
      },
      {
        title: '$vuetify.map.travelStats.eatingCount.title',
        value: this.eatingCount,
        icon: mdiFood
      },
      {
        title: '$vuetify.map.travelStats.smokingCount.title',
        value: this.smokingCount,
        icon: mdiSmoking
      }
    ]
  }
}
